import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/insta/tab/tab.module').then(m => m.TabPageModule)
  },
  {
    path: 'feed-edit/:id',
    loadChildren: () => import('./pages/insta/feed-edit/feed-edit.module').then(m => m.FeedEditPageModule)
  },
  {
    path: 'feed-edit',
    loadChildren: () => import('./pages/insta/feed-edit/feed-edit.module').then(m => m.FeedEditPageModule)
  },
  {
    path: 'otp-auth',
    loadChildren: () => import('./pages/otp-auth/otp-auth.module').then(m => m.OtpAuthPageModule)
  },

  {
    path: 'user-list',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/user/user-list/user-list.module').then(m => m.UserListPageModule)
  },
  {
    path: 'user-list/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/user/user-list/user-list.module').then(m => m.UserListPageModule)
  },
  {
    path: 'business-list',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/business/business-list/business-list.module').then(m => m.BusinessListPageModule)
  },
  {
    path: 'business-list/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/business/business-list/business-list.module').then(m => m.BusinessListPageModule)
  },
  {
    path: 'user-edit',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/user/user-edit/user-edit.module').then(m => m.UserEditPageModule)
  },
  {
    path: 'user-edit/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/user/user-edit/user-edit.module').then(m => m.UserEditPageModule)
  },
  {
    path: 'request/:mobile',
    loadChildren: () => import('./pages/request/request/request.module').then(m => m.RequestPageModule)
  },
  {
    path: 'request-list',
    loadChildren: () => import('./pages/request/request-list/request-list.module').then(m => m.RequestListPageModule)
  },
  {
    path: 'feed',
    loadChildren: () => import('./pages/insta/feed/feed.module').then(m => m.FeedPageModule)
  },
  {
    path: 'post-details/:id',
    loadChildren: () => import('./pages/insta/post-details/post-details.module').then(m => m.PostDetailsPageModule)
  },
  {
    path: 'master-list',
    loadChildren: () => import('./pages/master-list/master-list.module').then(m => m.MasterListPageModule)
  },
  {
    path: 'hierarchy-list/:businessId',
    loadChildren: () => import('./pages/hierarchy-list/hierarchy-list.module').then(m => m.HierarchyListPageModule)
  },
  {
    path: 'hierarchy-list/:businessId/:empId',
    loadChildren: () => import('./pages/hierarchy-list/hierarchy-list.module').then(m => m.HierarchyListPageModule)
  },
  {
    path: 'business-edit',
    loadChildren: () => import('./pages/business-edit/business-edit.module').then(m => m.BusinessEditPageModule)
  },
  {
    path: 'business-edit/:id',
    loadChildren: () => import('./pages/business-edit/business-edit.module').then(m => m.BusinessEditPageModule)
  },
  {
    path: 'relative-edit',
    loadChildren: () => import('./pages/user/relative-edit/relative-edit.module').then(m => m.RelativeEditPageModule)
  },
  {
    path: 'whats-app-otp',
    loadChildren: () => import('./pages/whats-app-otp/whats-app-otp.module').then(m => m.WhatsAppOtpPageModule)
  },
  {
    path: 'share',
    loadChildren: () => import('./pages/share/share.module').then(m => m.SharePageModule)
  },
  {
    path: 'share/:id',
    loadChildren: () => import('./pages/share/share.module').then(m => m.SharePageModule)
  },
  {
    path: 'tnc',
    loadChildren: () => import('./pages/tnc/tnc.module').then(m => m.TncPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard/dashboard.module').then(m => m.DashboardPageModule)
  },
  {
    path: 'community',
    loadChildren: () => import('./pages/community/community.module').then(m => m.CommunityPageModule)
  },
  {
    path: 'user-search',
    loadChildren: () => import('./pages/user/user-search/user-search.module').then(m => m.UserSearchPageModule)
  },
  {
    path: 'designations',
    loadChildren: () => import('./pages/business/designations/designations.module').then(m => m.DesignationsPageModule)
  },
  {
    path: 'designation-edit/:locationName/:locationType/:parent/:designationId',
    loadChildren: () => import('./pages/business/designation-edit/designation-edit.module').then(m => m.DesignationEditPageModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then(m => m.SettingsPageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'security-info',
    loadChildren: () => import('./pages/security-info/security-info.module').then(m => m.SecurityInfoPageModule)
  },
  {
    path: 'committee-list',
    loadChildren: () => import('./pages/committee-list/committee-list.module').then(m => m.CommitteeListPageModule)
  },
  {
    path: 'committee-details/:id',
    loadChildren: () => import('./pages/committee-details/committee-details.module').then(m => m.CommitteeDetailsPageModule)
  },
  {
    path: 'committee-edit',
    loadChildren: () => import('./pages/committee-edit/committee-edit.module').then(m => m.CommitteeEditPageModule)
  },
  {
    path: 'committee-edit/:id',
    loadChildren: () => import('./pages/committee-edit/committee-edit.module').then(m => m.CommitteeEditPageModule)
  },
  {
    path: 'donation-edit/:committee_id/:id',
    loadChildren: () => import('./pages/community/donation/donation-edit/donation-edit.module').then(m => m.DonationEditPageModule)
  },
  {
    path: 'donation-edit/:committee_id',
    loadChildren: () => import('./pages/community/donation/donation-edit/donation-edit.module').then(m => m.DonationEditPageModule)
  },
  {
    path: 'donation-details/:committee_id/:id',
    loadChildren: () => import('./pages/community/donation/donation-details/donation-details.module').then(m => m.DonationDetailsPageModule)
  },
  {
    path: 'election-edit/:id',
    loadChildren: () => import('./pages/election/election-edit/election-edit.module').then(m => m.ElectionEditPageModule)
  },
  {
    path: 'election-edit',
    loadChildren: () => import('./pages/election/election-edit/election-edit.module').then(m => m.ElectionEditPageModule)
  },
  {
    path: 'election-details/:id',
    loadChildren: () => import('./pages/election/election-details/election-details.module').then(m => m.ElectionDetailsPageModule)
  },
  {
    path: 'vote/:election_id',
    loadChildren: () => import('./pages/election/vote/vote.module').then(m => m.VotePageModule)
  },
  {
    path: 'register/:invitee/:empId',
    loadChildren: () => import('./pages/welcome-flow/welcome-flow.module').then(m => m.WelcomeFlowPageModule)
  },
  {
    path: 'register/:invitee',
    loadChildren: () => import('./pages/welcome-flow/welcome-flow.module').then(m => m.WelcomeFlowPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/welcome-flow/welcome-flow.module').then(m => m.WelcomeFlowPageModule)
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: 'history',
    loadChildren: () => import('./pages/history/history.module').then(m => m.HistoryPageModule)
  },
  {
    path: 'donation',
    loadChildren: () => import('./pages/donation/donation.module').then(m => m.DonationPageModule)
  },
  {
    path: 'help',
    loadChildren: () => import('./pages/help/help.module').then(m => m.HelpPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/insta/profile/profile.module').then(m => m.ProfilePageModule)
  },
  {
    path: 'election',
    loadChildren: () => import('./pages/election/election.module').then(m => m.ElectionPageModule)
  },
  // {
  //   path: 'version-update',
  //   loadChildren: () => import('./pages/version-update/version-update.module').then(m => m.VersionUpdatePageModule)
  // },
  {
    path: 'vani',
    loadChildren: () => import('./pages/vani/vani.module').then(m => m.VaniPageModule)
  },
  {
    path: 'account-deletion',
    loadChildren: () => import('./pages/account-deletion/account-deletion.module').then(m => m.AccountDeletionPageModule)
  },
  {
    path: 'child-safety-policy',
    loadChildren: () => import('./pages/child-safety-policy/child-safety-policy.module').then(m => m.ChildSafetyPolicyPageModule)
  },  {
    path: 'phone-book',
    loadChildren: () => import('./pages/phone-book/phone-book.module').then( m => m.PhoneBookPageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
